import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './checkbox.module.css'

const propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    labelClassName: PropTypes.string,
    labelIcon: PropTypes.node,
    labelIconClassName: PropTypes.string,
    multiline: PropTypes.bool,
    onClick: PropTypes.func
}

const defaultProps = {
    multiline: false
}

/**
 * Class representing a single checkbox input. Privately
 * used by Checkbox.
 *
 * @private
 * @param {string|number} [props.id] - The id from the corresponding input element
 * @param {ReactElement} [props.label] - The label element to be rendered
 * @param {string} [props.labelClassName] - Additional className for the label element
 * @param {ReactElement} [props.labelIcon] - The label icon element to be rendered
 * @param {string} [props.labelIconClassName] - Additional className for the label icon element
 * @param {boolean} [props.multiline=false] - Flag to enable different whitespace css rendering for long labels
 * @returns {ReactElement}
 */
function CheckboxLabel(props) {
    const { children, id, label, labelClassName, labelIcon, labelIconClassName, multiline, onClick } = props

    const classNameLabel = cx(
        styles['checkbox-label'],
        {
            [styles['is-multiline']]: multiline
        },
        labelClassName,
        't3sel-checkbox-label'
    )
    const classNameLabelIcon = cx(styles['checkbox-label-icon'], labelIconClassName)

    return (
        <label data-testid="checkbox-label" className={classNameLabel} htmlFor={id} onClick={onClick}>
            {labelIcon && <span className={classNameLabelIcon}>{labelIcon}</span>}
            {label || children}
        </label>
    )
}

CheckboxLabel.propTypes = propTypes
CheckboxLabel.defaultProps = defaultProps

export { CheckboxLabel }
